import type { ScriptCheck, SettingsResponse } from "../../shared/types";
import { TRACK_NAMES, type TrackKind, trackProblem } from "./rules";

/** One tool on the pages, as setup's ready screen and Settings read it. */
export interface TrackPart {
  kind: TrackKind;
  /** A pasted script's id; absent for Meta and Google, which Flashroom connects itself. */
  id?: string;
  name: string;
  /** The ID or "Your script", to show beside the name. */
  value: string | null;
  on: boolean;
  state: "loaded" | "waiting" | "bad" | "off";
}

function stateOf(on: boolean, problem: string, check: ScriptCheck): TrackPart["state"] {
  if (!on) return "off";
  if (problem) return "bad";
  return check.state === "good" ? "loaded" : "waiting";
}

/** Meta, Google and each pasted script: on, loaded, waiting for a visit, or needing a valid ID. */
export function trackParts(data: SettingsResponse): TrackPart[] {
  const m = data.measurement;
  const metaOn = m.meta_on && !!m.meta_pixel_id;
  const gaOn = m.ga_on && !!m.ga_measurement_id;
  const parts: TrackPart[] = [
    { kind: "meta", name: TRACK_NAMES.meta, value: m.meta_pixel_id, on: metaOn, state: stateOf(metaOn, trackProblem("meta", m.meta_pixel_id ?? ""), m.checks.pixel) },
    { kind: "ga", name: TRACK_NAMES.ga, value: m.ga_measurement_id, on: gaOn, state: stateOf(gaOn, trackProblem("ga", m.ga_measurement_id ?? ""), m.checks.ga) },
  ];
  for (const s of m.scripts) parts.push({ kind: "own", id: s.id, name: s.name, value: "Your script", on: s.on, state: stateOf(s.on, "", s.check) });
  return parts;
}
